module.exports = __webpack_public_path__ + "img/kal-visuals-square.779cce2b.jpg";